export default function Stepper({ current, total }) {
  return (
    <div className="flex items-center gap-2" data-testid="onboarding-stepper">
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className="flex-1 h-1 rounded-full transition-all"
          style={{
            background: i < current
              ? "linear-gradient(90deg, hsl(var(--klareet-blue)), hsl(var(--klareet-violet)))"
              : "hsl(var(--klareet-line))",
          }}
          data-testid={`step-${i + 1}${i < current ? "-active" : ""}`}
        />
      ))}
      <span className="klareet-mono k-quiet !text-xs ml-2" data-testid="stepper-count">
        {current} of {total}
      </span>
    </div>
  );
}
